module.exports = __webpack_public_path__ + "static/media/logo-black.e18db623.png";